<template>
    <div>
        <v-container>
            <v-row>
                <v-col>
                    <h2 style="padding-left:10px;">Settings</h2>
                </v-col>
            </v-row>
            <v-row v-if="!hideHint">

                <v-col class="pt-3">
                    <v-card>

                        <v-card-title>Install</v-card-title>
                        <v-card-subtitle class="text-h6">For compatible browsers</v-card-subtitle>
                        <v-card-text>
                            Click the install button bellow to access the app from your devices homescreen.
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn v-on:click="hideHint = true" class="float-right"
                                :color="($vuetify.theme.dark) ? 'darkPrimeBack' : 'lightPrimeBack'">Help</v-btn>
                            <v-btn v-if="installPrompt != null" v-on:click="installPWA()" class="float-right"
                                :color="($vuetify.theme.dark) ? 'darkPrimeBack' : 'lightPrimeBack'">Install</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <PushNotification class="pt-3" v-if="!hideHint"></PushNotification>
                </v-col>
            </v-row>


            <v-row v-if="!hideHint">
                <v-col class="pt-3">
                    <v-card>
                        <v-card-title>Version - {{ appVersion }}</v-card-title>
                        <v-card-text>©Copyright 2022 Stratford Consulting LTD</v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <!-- Hint page -->
            <v-card v-if="hideHint">
                <v-card-subtitle class="text-h6">Chrome/Edge/Opera</v-card-subtitle>
                <v-card-text>
                    This app can be installed to mobile or desktop as an application.
                    Simply click the install button below using either of these browsers and you will see
                    the app icon appear on your devices homescreen.
                </v-card-text>
                <v-card-subtitle class="text-h6">Safari</v-card-subtitle>

                <v-card-text>
                    If you are using Safari, choose the Share up-arrow at the bottom of the screen, and
                    select Add to Home Screen.
                </v-card-text>
                <v-card-subtitle class="text-h6">FireFox - (Android)</v-card-subtitle>
                <v-card-text>
                    <ol>
                        <li>Press the Menu button (either below the screen on some devices or in the upper
                            right of the browser)</li>
                        <li>Tap 'Add to Home Screen'.</li>
                        <li>Your shortcut should now appear on your home screen.</li>
                    </ol>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn v-on:click="hideHint = false" class="float-right"
                        :color="($vuetify.theme.dark) ? 'darkPrimeBack' : 'lightPrimeBack'">Back</v-btn>
                    <v-btn v-if="installPrompt != null" v-on:click="installPWA()" class="float-right"
                        :color="($vuetify.theme.dark) ? 'darkPrimeBack' : 'lightPrimeBack'">Install</v-btn>
                </v-card-actions>
            </v-card>
        </v-container>
    </div>
</template>
 

<script>
import accessHelper from '../mixins/accessHelper'
import PushNotification from "../components/PushNotification.vue";
import { mapGetters, mapActions } from 'vuex';

export default {
    name: "SettingsPage",
    mixins: [accessHelper],
    props: {

    },
    components: {
        PushNotification
    },
    data: () => ({
        spinner: false,
        chosenColor: "",
        deferredPrompt: null,
        hideHint: false,
    }),
    mounted: function () {
        this.existingColorCheck();
    },
    computed:
        mapGetters([
            'installPrompt',
            'appVersion'
        ]),
    methods: {
        ...mapActions([
            'fetchAccount',
            'fetchAccountBalance',
            'logoutFromApp',
            'saveInstallPromptCaught',
        ]),
        switchMode() {
            this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
            localStorage.setItem('darkMode', this.$vuetify.theme.dark);
        },
        installPWA() {
            let promptE = this.installPrompt;
            promptE.prompt()
            promptE.userChoice.then((choice) => {
                this.dismissPrompt(); // Hide the prompt once the user's clicked
                if (choice.outcome === 'accepted') {
                    // Do something additional if the user chose to install
                } else {
                    // Do something additional if the user declined
                }
            })
        },
        updateTheme: function () {
            //as long as R is bellow 200 won't be too white
            localStorage.setItem(process.env.VUE_APP_THEME, this.chosenColor);
            this.$emit("theme", this.chosenColor);
        },
        //Checks for color in localStorage, otherwise using default
        existingColorCheck: function () {
            if (localStorage.getItem(process.env.VUE_APP_THEME) === null)
                localStorage.setItem(process.env.VUE_APP_THEME, process.env.VUE_APP_DEFAULT_THEME_COLOR);
            else
                this.chosenColor = localStorage.getItem(process.env.VUE_APP_THEME);
        },
        snackmain: function (message) {
            this.$emit('snack', message);
        }
    },
}
</script>

<style scoped>
</style>